import React from 'react';

const googleMapsKey = 'AIzaSyCsEuLdHnu5Iyo1xtAe0xg-VGlZ0_xWyhs';

export default class SmallMap extends React.Component {

  render() {
    let search = encodeURIComponent(this.props.area.area_full);
    let mapSrc = `https://www.google.com/maps/embed/v1/place?key=${googleMapsKey}&zoom=14&q=${search}&language=pt-br`;
    return(
      <div style={{'width': '300px', 'height': '300px'}}>
         <iframe title='gmap' width='300' height='300' frameBorder='0' style={{'border': '0px'}}
                 src={mapSrc}></iframe>
      </div>
    );
  }
}
